"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.stringify.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _leads = require("@/api/leads");
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _index2 = require("@/utils/index");
var _index3 = _interopRequireDefault(require("@/components/Enabled/index.vue"));
var _clients = require("@/api/clients");
var _sources = require("@/api/master/sources");
var _index4 = _interopRequireDefault(require("@/components/Inr/index.vue"));
var _categories = require("@/api/categories");
var _clientsContacts = require("@/api/clients-contacts");
var _admin = require("@/store/modules/admin");
var _admins = require("@/api/admins");
var _excel = require("@/utils/excel");
var _products = require("@/api/products");
// import { formatJson } from '@/utils'
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.clientList = [];
    this.clientContactList = [];
    this.salesManagerList = [];
    this.sourceList = [];
    this.conceptList = [];
    this.categoryList = [];
    this.dateRange = '';
    this.priceRange = [0, 0];
    this.selectedLeadId = null;
    this.selectedColumn = '';
    this.loggedInUser = _admin.AdminModule;
    this.productList = [];
    this.isAdmin = false;
    this.isDispatcher = false;
    this.productDialogVisible = false;
    this.selectedProducts = [];
    this.listQuery = {
      page: 1,
      limit: 10,
      enabled: true,
      clientId: undefined,
      clientsContactId: undefined,
      createdTimestamp: undefined,
      budget: undefined,
      sourceId: undefined,
      // conceptId: undefined,
      status: undefined,
      noFollowup: undefined,
      missedFollowUp: undefined,
      isSampleSent: undefined,
      isPresentationSent: undefined,
      isQuotationSent: undefined,
      createdBy: undefined,
      salesCoordinatorId: undefined,
      salesManagerId: undefined,
      sort: 'DESC',
      isSuperAdminTask: undefined,
      productId: undefined
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'ASC'
    }, {
      label: 'ID Descending',
      key: 'DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
    this.statusList = [{
      key: 'New',
      value: 'New',
      info: "When an inquiry is received but the team hasn't spoken with client even once, the status is marked as New"
    }, {
      key: 'Contacted',
      value: 'Contacted',
      info: 'Whenever team speaks with client once, the status is changed to Contacted'
    }, {
      key: 'Won',
      value: 'Won',
      info: 'When an inquiry is won i.e. converted into an order, the status is changed to Won'
    }, {
      key: 'Lost',
      value: 'Lost',
      info: ' When an inquiry is dropped i.e. not converted into an order, the status is changed to Lost'
    }];
    this.leadStatusColorMap = {
      New: 'info',
      Contacted: 'warning',
      Won: 'success',
      Lost: 'danger'
    };
  }
  openProductDialog(products) {
    this.selectedProducts = products;
    this.productDialogVisible = true;
  }
  adminType() {
    if (_admin.AdminModule.roles.toString() === 'Super Admin') {
      return 'Super Admin';
    } else if (_admin.AdminModule.roles.toString() === 'Admin') {
      return 'Admin';
    } else if (_admin.AdminModule.roles.toString() === 'Sales Coordinator') {
      return 'Sales Coordinator';
    } else {
      return 'User';
    }
  }
  created() {
    this.isDispatcher = _admin.AdminModule.roles.toString() === 'Dispatcher';
    this.isAdmin = _admin.AdminModule.roles.toString() === 'Super Admin' || _admin.AdminModule.roles.toString() === 'Admin';
    // set Query
    this.setQuery();
    // fetch leads
    this.getList();
    // fetch sources
    this.fetchSourceList();
    // fetch concepts
    // fetch categories
    this.fetchCategoryList();
    // fetch sales manger
    this.fetchSalesManagerList();
    this.watchQuery();
  }
  // Watch for route changes
  watchQuery() {
    this.$watch(() => this.$route.query, () => {
      this.getList();
    }, {
      immediate: true
    });
  }
  async getList(id = null, column = null) {
    try {
      this.listLoading = true;
      if (this.dateRange) {
        this.listQuery.createdTimestamp = [this.dateRange.start, this.dateRange.end];
      }
      if (this.$route.query.page) {
        this.listQuery.page = +this.$route.query.page;
      } else {
        this.listQuery.page = 1;
      }
      if (this.$route.query.limit) {
        this.listQuery.limit = +this.$route.query.limit;
      }
      const safeQuery = {
        ...this.listQuery
      };
      // ❌ REMOVE THIS (WRONG)
      // safeQuery.enabled = safeQuery.enabled ? 1 : 0;
      // ✅ generate base query (UNCHANGED)
      let queryString = (0, _index2.getQuery)(safeQuery);
      // ❌ REMOVE THIS (VERY IMPORTANT)
      // queryString = queryString.replace(/\$contL/g, '$cont');
      // ✅ ADD THIS (GLOBAL SEARCH FIX)
      if (safeQuery.search) {
        const s = encodeURIComponent(safeQuery.search);
        const searchFilters = [`filter=$or||firstName||$contL||${s}`, `filter=$or||lastName||$contL||${s}`, `filter=$or||mobileNumber||$cont||${s}`, `filter=$or||emailAddress||$contL||${s}`, `filter=$or||client.name||$contL||${s}`].join('&');
        queryString += (queryString ? '&' : '') + searchFilters;
      }
      const data = await (0, _leads.getLeads)(queryString);
      this.list = data.data;
      this.total = data.total;
    } catch (error) {
      var _error$response;
      console.error('Backend Error:', ((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) || error.message);
    } finally {
      this.listLoading = false;
    }
  }
  getTeamInfo(row) {
    var _row$salesManager, _row$salesCoordinator;
    const role = this.adminType();
    const manager = (_row$salesManager = row.salesManager) === null || _row$salesManager === void 0 ? void 0 : _row$salesManager.fullName;
    const coordinator = (_row$salesCoordinator = row.salesCoordinator) === null || _row$salesCoordinator === void 0 ? void 0 : _row$salesCoordinator.fullName;
    // Sales Coordinator → only Manager
    if (role === 'Sales Coordinator') {
      return manager || 'No Manager Assigned';
    }
    // Admin → show both properly formatted
    if (role === 'Admin') {
      const parts = [manager, coordinator].filter(Boolean);
      return parts.length ? parts.join(' - ') : 'No Team Assigned';
    }
    // Super Admin → only Coordinator
    if (role === 'Super Admin') {
      return coordinator || 'No Coordinator Assigned';
    }
    return 'No Team Assigned';
  }
  setQuery() {
    const queries = this.$route.query;
    // loop over queries
    for (const field in queries) {
      let value = queries[field] || undefined;
      if (value === 'null') {
        value = undefined;
      }
      if (value === 'true') {
        value = true;
      }
      if (value === 'false') {
        value = false;
      }
      // check if field is present in listQuery, set
      if (field in this.listQuery) {
        this.listQuery[field] = value;
      }
      if (field === 'statuses') {
        this.listQuery.status = value.split(',');
        // this.listQuery.filter.status = '$in'
      }
      // check if its createdTimestamp, set for dateRange
      if (field === 'createdTimestamp' && value) {
        const dates = value.split(',');
        const startDate = this.$moment(dates[0], 'YYYY-MM-DD hh:mm a').toDate();
        const endDate = this.$moment(dates[1], 'YYYY-MM-DD hh:mm a').toDate();
        this.dateRange = {
          start: startDate,
          end: endDate
        };
      }
    }
    // check if createdBy is not set
    // add or condition for if user is not super admin or admin
    if (!['Super Admin', 'Admin', 'Dispatcher'].includes(_admin.AdminModule.roles.toString())) {
      // add id to these fields
      this.listQuery.createdBy = _admin.AdminModule.id;
      this.listQuery.salesCoordinatorId = _admin.AdminModule.id;
      this.listQuery.salesManagerId = _admin.AdminModule.id;
    }
    if (['Dispatcher'].includes(_admin.AdminModule.roles.toString())) {
      this.listQuery.dispatcherId = _admin.AdminModule.id;
    }
  }
  async fetchProductList(query = '', force = false) {
    try {
      if (query.length > 1 || force) {
        this.productList = await (0, _products.getProducts)((0, _index2.getQuery)({
          enabled: true,
          name: query || undefined,
          filter: {
            enabled: '$eq',
            name: '$contL'
          }
        }));
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  maskSensitiveInfo(input) {
    if (input.includes('@')) {
      // If it's an email
      const atIndex = input.indexOf('@');
      return input.slice(0, atIndex - 3) + '*' + input.slice(atIndex);
    } else if (input.match(/^\d+$/)) {
      // If it's a mobile number
      return input.slice(0, -4).replace(/\d/g, '*') + input.slice(-4);
    } else {
      // Otherwise, assuming it's a full name
      const nameParts = input.split(' ');
      return nameParts.map((part, index) => index === 0 ? part : '*'.repeat(part.length)).join(' ');
    }
  }
  showSecurityDialog(id, column) {
    this.selectedLeadId = id;
    this.selectedColumn = column;
    this.getList(this.selectedLeadId, this.selectedColumn);
  }
  async fetchClientList(query = '') {
    try {
      if (query.length > 0) {
        this.clientList = await (0, _clients.getClients)((0, _index2.getQuery)({
          enabled: true,
          name: query,
          sort: 'name,ASC',
          filter: {
            enabled: '$eq',
            name: '$contL'
          }
        }));
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchClientContactList(query = '') {
    try {
      if (query.length > 0) {
        const searchObj = {
          $or: [{
            firstName: {
              $contL: query
            }
          }, {
            lastName: {
              $contL: query
            }
          }, {
            mobileNumber: {
              $cont: query
            }
          }, {
            emailAddress: {
              $contL: query
            }
          }]
        };
        const queryString = `
        filter=enabled||$eq||true
        &s=${encodeURIComponent(JSON.stringify(searchObj))}
        &sort=firstName,ASC
      `.replace(/\s+/g, '');
        this.clientContactList = await (0, _clientsContacts.getClientsContacts)('?' + queryString);
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchSalesManagerList() {
    try {
      this.salesManagerList = await (0, _admins.getAdmins)((0, _index2.getQuery)({
        enabled: true,
        sort: 'fullName,ASC',
        filter: {
          enabled: '$eq'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchSourceList() {
    try {
      this.sourceList = await (0, _sources.getSources)((0, _index2.getQuery)({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchCategoryList() {
    try {
      this.categoryList = await (0, _categories.getCategories)((0, _index2.getQuery)({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      this.listQuery.createdTimestamp = [this.dateRange.start, this.dateRange.end];
    }
    // Update the route query to reflect new filters (reset page to 1)
    this.$router.push({
      path: this.$route.path,
      query: {
        ...this.$route.query,
        page: '1'
      }
    });
    this.getList();
  }
  sortChange(data) {
    this.handleFilter();
  }
  getStatusInfo(status) {
    var _this$statusList$find;
    return (_this$statusList$find = this.statusList.find(item => item.key === status).info) !== null && _this$statusList$find !== void 0 ? _this$statusList$find : 'NA';
  }
  canReopen(row) {
    if (row.status !== 'Lost') return false;
    const cutoff = new Date();
    cutoff.setDate(cutoff.getDate() - 30);
    return new Date(row.lostAt || row.updatedTimestamp) >= cutoff;
  }
  async reopenLead(id) {
    try {
      await this.$confirm('This will change the lead status back to Contacted. Continue?', 'Reopen Lead', {
        confirmButtonText: 'Reopen',
        cancelButtonText: 'Cancel',
        type: 'warning'
      });
      await (0, _leads.reopenLead)(id);
      this.$notify({
        title: 'Success',
        message: 'Lead reopened successfully',
        type: 'success',
        duration: 2000
      });
      this.getList();
    } catch {
      // user cancelled confirmation
    }
  }
  async deleteLead(id) {
    try {
      this.$confirm('Are you sure you want to delete this Inquiry?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(async () => {
        await (0, _leads.deleteLead)(`${id}`);
        this.$notify({
          title: 'Success',
          type: 'success',
          message: 'Inquiry deleted successfully'
        });
        this.getList();
      }).catch(() => {
        this.$notify({
          title: 'Cancelled',
          type: 'info',
          message: 'Delete action cancelled'
        });
      });
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async handleQuickDownload() {
    this.downloadLoading = true;
    const listQuery = {
      ...this.listQuery
    };
    delete listQuery.limit;
    if (this.dateRange) {
      this.listQuery.createdTimestamp = [this.dateRange.start, this.dateRange.end];
    }
    const response = await (0, _leads.getLeads)((0, _index2.getQuery)(listQuery));
    const list = response.data;
    const tHeader = ['ID', 'Client', 'Contact FirstName & LastName', 'Budget Per Piece', 'Quantity', 'Budget', 'Sales Person', 'Created On', 'Expected Closure Date', 'Status', 'Products'];
    const filterVal = ['id', 'client.name', 'clientsContactFullName', 'budgetPerPiece', 'quantity', 'budget', 'salesManager.fullName', 'createdTimestamp', 'expectedClosureDate', 'status', 'leadsProduct'];
    const currentDate = new Date().toLocaleDateString('en-GB'); // dd/mm/yyyy format
    const generatedBy = _admin.AdminModule.name; // Replace with dynamic user data if needed
    // Add metadata rows
    const metaData = [['Date of Report', currentDate], ['Generated By', generatedBy], [] // Empty row for spacing
    ];
    // Prepare main table data
    const data = (0, _index2.formatJson)(filterVal, list);
    (0, _excel.exportInquiryJson2Excel)([...metaData, tHeader, ...data], 'Inquiries Data');
    this.downloadLoading = false;
  }
  async handleComprehensiveDownload() {
    this.downloadLoading = true;
    const listQuery = {
      ...this.listQuery
    };
    delete listQuery.limit;
    if (this.dateRange) {
      this.listQuery.createdTimestamp = [this.dateRange.start, this.dateRange.end];
    }
    const response = await (0, _leads.getLeads)((0, _index2.getQuery)(listQuery));
    const list = response.data;
    const tHeader = ['ID', 'Client', 'Contact FirstName & LastName', 'Budget Per Piece', 'Quantity', 'Budget', 'Categorization', 'Created On', 'Expected Closure Date', 'Status', 'Sales Person', 'Sales Coordinator', 'Type', 'No Followup', 'Missed Follow Up', 'Last Action Taken', 'Date of Last Action Taken', 'Next Action To be Taken', 'Products', 'Source', 'Concept', 'Comments', 'Presentation PDF', 'Quote PDF'];
    const filterVal = ['id', 'client.name', 'clientsContactFullName', 'budgetPerPiece', 'quantity', 'budget', 'categorization', 'createdTimestamp', 'expectedClosureDate', 'status', 'salesManager.fullName', 'salesCoordinator.fullName', 'productAction', 'noFollowup', 'missedFollowUp', 'followUp.1.agenda', 'followUp.1.completedTimestamp', 'followUp.0.agenda', 'leadsProduct', 'source.name', 'concept.name', 'comments', 'presentationUrl', 'pdfUrl'];
    const currentDate = new Date().toLocaleDateString('en-GB'); // dd/mm/yyyy format
    const generatedBy = _admin.AdminModule.name; // Replace with dynamic user data if needed
    // Add metadata rows
    const metaData = [['Date of Report', currentDate], ['Generated By', generatedBy], [] // Empty row for spacing
    ];
    // Prepare main table data
    const data = (0, _index2.formatJson)(filterVal, list);
    (0, _excel.exportInquiryJson2Excel)([...metaData, tHeader, ...data], 'Inquiries Data');
    this.downloadLoading = false;
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LeadList',
  components: {
    Pagination: _index.default,
    Enabled: _index3.default,
    Inr: _index4.default
  }
})], default_1);
var _default = exports.default = default_1;